// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.coincircle",
    name: "CoinCircle",
    homepage: "https://coincircle.com",
    image_id: "eae63a23-c7ba-4f7e-24b3-e6fc69215d00",
    app: {
        browser: "https://coincircle.com",
        ios: "https://coincircle.com/app",
        android: "https://coincircle.com/app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://coincircle.com/app/walletconnect",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map